import { render, staticRenderFns } from "./LicitacaoVisualizacaoDadosEdital.vue?vue&type=template&id=7b221bc6&"
import script from "./LicitacaoVisualizacaoDadosEdital.vue?vue&type=script&lang=js&"
export * from "./LicitacaoVisualizacaoDadosEdital.vue?vue&type=script&lang=js&"
import style0 from "./LicitacaoVisualizacaoDadosEdital.vue?vue&type=style&index=0&id=7b221bc6&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports